export const UMO_RETRIEVE_REQUEST = 'UMO_RETRIEVE_REQUEST';
export const UMO_RETRIEVE_SUCCESS = 'UMO_RETRIEVE_SUCCESS';
export const UMO_RETRIEVE_FAILURE = 'UMO_RETRIEVE_FAILURE';

export const UMO_ADD_TO_WORKSPACE_REQUEST = 'UMO_ADD_TO_WORKSPACE_REQUEST';
export const UMO_ADD_TO_WORKSPACE_SUCCESS = 'UMO_ADD_TO_WORKSPACE_SUCCESS';
export const UMO_ADD_TO_WORKSPACE_FAILURE = 'UMO_ADD_TO_WORKSPACE_FAILURE';

export const UMO_MOVE_BETWEEN_WORKSPACES_REQUEST = 'UMO_MOVE_BETWEEN_WORKSPACES_REQUEST';
export const UMO_MOVE_BETWEEN_WORKSPACES_SUCCESS = 'UMO_MOVE_BETWEEN_WORKSPACES_SUCCESS';
export const UMO_MOVE_BETWEEN_WORKSPACES_FAILURE = 'UMO_MOVE_BETWEEN_WORKSPACES_FAILURE';
export const UMO_MOVE_BETWEEN_WORKSPACES_RESTRICTION_FAILURE = 'UMO_MOVE_BETWEEN_WORKSPACES_RESTRICTION_FAILURE';

export const UMO_REMOVE_FROM_WORKSPACE_REQUEST = 'UMO_REMOVE_FROM_WORKSPACE_REQUEST';
export const UMO_REMOVE_FROM_WORKSPACE_SUCCESS = 'UMO_REMOVE_FROM_WORKSPACE_SUCCESS';
export const UMO_REMOVE_FROM_WORKSPACE_FAILURE = 'UMO_REMOVE_FROM_WORKSPACE_FAILURE';

export const UMO_MOVE_REQUEST = 'UMO_MOVE_REQUEST';
export const UMO_MOVE_SUCCESS = 'UMO_MOVE_SUCCESS';
export const UMO_MOVE_FAILURE = 'UMO_MOVE_FAILURE';

export const UMO_RELATE_REQUEST = 'UMO_RELATE_REQUEST';
export const UMO_RELATE_SUCCESS = 'UMO_RELATE_SUCCESS';
export const UMO_RELATE_FAILURE = 'UMO_RELATE_FAILURE';

export const UMO_RATING_REQUEST = 'UMO_RATING_REQUEST';
export const UMO_RATING_SUCCESS = 'UMO_RATING_SUCCESS';
export const UMO_RATING_FAILURE = 'UMO_RATING_FAILURE';

export const TERM_ATTACH_UMOS_REQUEST = 'TERM_ATTACH_UMOS_REQUEST';
export const TERM_ATTACH_UMOS_SUCCESS = 'TERM_ATTACH_UMOS_SUCCESS';
export const TERM_ATTACH_UMOS_FAILURE = 'TERM_ATTACH_UMOS_FAILURE';
